// extracted by mini-css-extract-plugin
export default {"general-label":"generalLabels_general-label__YYutM","search-label":"generalLabels_search-label__eTgKO","consistent-text-view":"generalLabels_consistent-text-view__U8QoI"};